import { onlyNumbers, hasAnyLetter } from '@/utils/regex-utils';

export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  fornecedor(state) {
    return state.fornecedor;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  grupo(state) {
    return state.grupo;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.fornecedor && state.fornecedor.length,
      state.dataFinal,
      state.dataInicial,
      state.grupo && state.grupo.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(`situacao in ('${state.selectedStatus.value.join('\',\'')}')`);
    }
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      const idFilter = !hasAnyLetter(state.searchText) ? ` or id = ${onlyNumbers(state.searchText)}` : '';
      filters.push(`(identificador like '%${searchText}%' or responsavel.name like '%${searchText}%'${idFilter})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id} or produto.centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id} or produto.projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.fornecedor && state.fornecedor.length) {
      const fornecedorFilter = state.fornecedor.map(fornecedor => `(fornecedor.id = ${fornecedor.id})`);
      filters.push(`(${fornecedorFilter.join(' or ')})`);
    }
    if (state.dataInicial) {
      filters.push(`dataRegistro >= ${state.dataInicial}`);
    }
    if (state.dataFinal) {
      filters.push(`dataRegistro <= ${state.dataFinal}`);
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(categoria => `(produto.categoria.id = ${categoria.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    return filters.join(' and  ');
  },
};
